/* eslint-disable */
import React from "react";
import NetlifyIdentityContext from "react-netlify-identity-gotrue";
import appConfig from "./src/modules/appConfig";

export const wrapRootElement = ({ element }) => {
  let url = appConfig.url;
  if (url.charAt(url.length - 1) === "/") {
    url = url.slice(0, -1);
  }
  return <NetlifyIdentityContext url={url}>{element}</NetlifyIdentityContext>;
};
